/**
 *
 * carbon-angular v0.0.0 | carbon-components-angular-datepicker-input.js
 *
 * Copyright 2014, 2023 IBM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0

 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ElementRef, TemplateRef, ViewChild, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IconModule } from 'carbon-components-angular/icon';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'carbon-components-angular/icon';

const _c0 = ["input"];
function DatePickerInput_label_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.label);
} }
function DatePickerInput_label_3_2_ng_template_0_Template(rf, ctx) { }
function DatePickerInput_label_3_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DatePickerInput_label_3_2_ng_template_0_Template, 0, 0, "ng-template", 13);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.label);
} }
function DatePickerInput_label_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 11);
    ɵngcc0.ɵɵtemplate(1, DatePickerInput_label_3_ng_container_1_Template, 2, 1, "ng-container", 12);
    ɵngcc0.ɵɵtemplate(2, DatePickerInput_label_3_2_Template, 1, 1, null, 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("for", ctx_r0.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isTemplate(ctx_r0.label));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isTemplate(ctx_r0.label));
} }
const _c1 = function (a0, a1) { return { "bx--date-picker__input--sm": a0, "bx--date-picker__input--xl": a1 }; };
function DatePickerInput_input_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 14, 15);
    ɵngcc0.ɵɵlistener("change", function DatePickerInput_input_5_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r12.onChange($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c1, ctx_r1.size === "sm", ctx_r1.size === "xl"))("value", ctx_r1.value)("pattern", ctx_r1.pattern)("placeholder", ctx_r1.placeholder)("id", ctx_r1.id)("disabled", ctx_r1.disabled);
    ɵngcc0.ɵɵattribute("data-invalid", ctx_r1.invalid ? true : undefined);
} }
function DatePickerInput__svg_svg_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "svg", 16);
} }
function DatePickerInput__svg_svg_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "svg", 17);
} }
function DatePickerInput__svg_svg_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "svg", 18);
} }
function DatePickerInput_div_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.helperText);
} }
function DatePickerInput_div_9_2_ng_template_0_Template(rf, ctx) { }
function DatePickerInput_div_9_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DatePickerInput_div_9_2_ng_template_0_Template, 0, 0, "ng-template", 13);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.helperText);
} }
const _c2 = function (a0) { return { "bx--form__helper-text--disabled": a0 }; };
function DatePickerInput_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, DatePickerInput_div_9_ng_container_1_Template, 2, 1, "ng-container", 12);
    ɵngcc0.ɵɵtemplate(2, DatePickerInput_div_9_2_Template, 1, 1, null, 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c2, ctx_r5.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.isTemplate(ctx_r5.helperText));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.isTemplate(ctx_r5.helperText));
} }
function DatePickerInput_div_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r17.invalidText);
} }
function DatePickerInput_div_10_2_ng_template_0_Template(rf, ctx) { }
function DatePickerInput_div_10_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DatePickerInput_div_10_2_ng_template_0_Template, 0, 0, "ng-template", 13);
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r18.invalidText);
} }
function DatePickerInput_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵtemplate(1, DatePickerInput_div_10_ng_container_1_Template, 2, 1, "ng-container", 12);
    ɵngcc0.ɵɵtemplate(2, DatePickerInput_div_10_2_Template, 1, 1, null, 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r6.isTemplate(ctx_r6.invalidText));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.isTemplate(ctx_r6.invalidText));
} }
function DatePickerInput_div_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r20.warnText);
} }
function DatePickerInput_div_11_2_ng_template_0_Template(rf, ctx) { }
function DatePickerInput_div_11_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DatePickerInput_div_11_2_ng_template_0_Template, 0, 0, "ng-template", 13);
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r21.warnText);
} }
function DatePickerInput_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵtemplate(1, DatePickerInput_div_11_ng_container_1_Template, 2, 1, "ng-container", 12);
    ɵngcc0.ɵɵtemplate(2, DatePickerInput_div_11_2_Template, 1, 1, null, 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.isTemplate(ctx_r7.warnText));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.isTemplate(ctx_r7.warnText));
} }
const _c3 = function (a0, a1, a2, a3, a4) { return { "bx--date-picker--simple": a0, "bx--date-picker--single": a1, "bx--date-picker--range": a2, "bx--date-picker--light": a3, "bx--skeleton": a4 }; };
const _c4 = function (a0, a1) { return { "bx--date-picker-input__wrapper--invalid": a0, "bx--date-picker-input__wrapper--warn": a1 }; };
class DatePickerInput {
    constructor(elementRef) {
        this.elementRef = elementRef;
        /**
         * Select a calendar type for the `model`.
         * Internal purposes only.
         */
        this.type = "simple";
        this.id = `datepicker-${DatePickerInput.datePickerCount++}`;
        this.hasIcon = false;
        this.placeholder = "mm/dd/yyyy";
        this.pattern = "^\\d{1,2}/\\d{1,2}/\\d{4}$";
        this.valueChange = new EventEmitter();
        this.theme = "dark";
        this.disabled = false;
        /**
         * Set to `true` for invalid state.
         */
        this.invalid = false;
        /**
          * Set to `true` to show a warning (contents set by warnText)
          */
        this.warn = false;
        this.skeleton = false;
        this.value = "";
        this.size = "md";
        this.onTouched = () => { };
        this.propagateChange = (_) => { };
    }
    onChange(event) {
        this.value = event.target.value;
        this.valueChange.emit(this.value);
        this.propagateChange(this.value);
        this.onTouched();
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    isTemplate(value) {
        return value instanceof TemplateRef;
    }
}
DatePickerInput.ɵfac = function DatePickerInput_Factory(t) { return new (t || DatePickerInput)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DatePickerInput.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatePickerInput, selectors: [["ibm-date-picker-input"]], viewQuery: function DatePickerInput_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { type: "type", id: "id", hasIcon: "hasIcon", placeholder: "placeholder", pattern: "pattern", theme: "theme", disabled: "disabled", invalid: "invalid", warn: "warn", skeleton: "skeleton", value: "value", size: "size", label: "label", invalidText: "invalidText", warnText: "warnText", helperText: "helperText" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: DatePickerInput,
                multi: true
            }
        ])], decls: 12, vars: 19, consts: [[1, "bx--form-item"], [1, "bx--date-picker", 3, "ngClass"], [1, "bx--date-picker-container"], ["class", "bx--label", 3, "for", 4, "ngIf"], [1, "bx--date-picker-input__wrapper", 3, "ngClass"], ["autocomplete", "off", "type", "text", "class", "bx--date-picker__input", 3, "ngClass", "value", "pattern", "placeholder", "id", "disabled", "change", 4, "ngIf"], ["ibmIcon", "calendar", "size", "16", "class", "bx--date-picker__icon", 4, "ngIf"], ["class", "bx--date-picker__icon bx--date-picker__icon--invalid", "ibmIcon", "warning--filled", "size", "16", 4, "ngIf"], ["ibmIcon", "warning--alt--filled", "size", "16", "class", "bx--date-picker__icon bx--date-picker__icon--warn", 4, "ngIf"], ["class", "bx--form__helper-text", 3, "ngClass", 4, "ngIf"], ["class", "bx--form-requirement", 4, "ngIf"], [1, "bx--label", 3, "for"], [4, "ngIf"], [3, "ngTemplateOutlet"], ["autocomplete", "off", "type", "text", 1, "bx--date-picker__input", 3, "ngClass", "value", "pattern", "placeholder", "id", "disabled", "change"], ["input", ""], ["ibmIcon", "calendar", "size", "16", 1, "bx--date-picker__icon"], ["ibmIcon", "warning--filled", "size", "16", 1, "bx--date-picker__icon", "bx--date-picker__icon--invalid"], ["ibmIcon", "warning--alt--filled", "size", "16", 1, "bx--date-picker__icon", "bx--date-picker__icon--warn"], [1, "bx--form__helper-text", 3, "ngClass"], [1, "bx--form-requirement"]], template: function DatePickerInput_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, DatePickerInput_label_3_Template, 3, 3, "label", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, DatePickerInput_input_5_Template, 2, 10, "input", 5);
        ɵngcc0.ɵɵtemplate(6, DatePickerInput__svg_svg_6_Template, 1, 0, "svg", 6);
        ɵngcc0.ɵɵtemplate(7, DatePickerInput__svg_svg_7_Template, 1, 0, "svg", 7);
        ɵngcc0.ɵɵtemplate(8, DatePickerInput__svg_svg_8_Template, 1, 0, "svg", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, DatePickerInput_div_9_Template, 3, 5, "div", 9);
        ɵngcc0.ɵɵtemplate(10, DatePickerInput_div_10_Template, 3, 2, "div", 10);
        ɵngcc0.ɵɵtemplate(11, DatePickerInput_div_11_Template, 3, 2, "div", 10);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction5(10, _c3, ctx.type === "simple", ctx.type === "single", ctx.type === "range", ctx.theme === "light", ctx.skeleton));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(16, _c4, ctx.invalid, ctx.warn));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.skeleton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type !== "simple" && !ctx.warn && !ctx.invalid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.warn && ctx.invalid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.invalid && ctx.warn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helperText && !ctx.invalid && !ctx.warn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.warn && ctx.invalid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.invalid && ctx.warn);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.IconDirective], encapsulation: 2 });
DatePickerInput.datePickerCount = 0;
/** @nocollapse */
DatePickerInput.ctorParameters = () => [
    { type: ElementRef }
];
DatePickerInput.propDecorators = {
    type: [{ type: Input }],
    id: [{ type: Input }],
    hasIcon: [{ type: Input }],
    label: [{ type: Input }],
    placeholder: [{ type: Input }],
    pattern: [{ type: Input }],
    valueChange: [{ type: Output }],
    theme: [{ type: Input }],
    disabled: [{ type: Input }],
    invalid: [{ type: Input }],
    invalidText: [{ type: Input }],
    warn: [{ type: Input }],
    warnText: [{ type: Input }],
    helperText: [{ type: Input }],
    skeleton: [{ type: Input }],
    value: [{ type: Input }],
    size: [{ type: Input }],
    input: [{ type: ViewChild, args: ["input", { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatePickerInput, [{
        type: Component,
        args: [{
                selector: "ibm-date-picker-input",
                template: `
	<div class="bx--form-item">
		<div class="bx--date-picker"
			[ngClass]="{
				'bx--date-picker--simple' : type === 'simple',
				'bx--date-picker--single' : type === 'single',
				'bx--date-picker--range' : type === 'range',
				'bx--date-picker--light' : theme === 'light',
				'bx--skeleton' : skeleton
			}">
			<div class="bx--date-picker-container">
				<label *ngIf="label" [for]="id" class="bx--label">
					<ng-container *ngIf="!isTemplate(label)">{{label}}</ng-container>
					<ng-template *ngIf="isTemplate(label)" [ngTemplateOutlet]="label"></ng-template>
				</label>
				<div class="bx--date-picker-input__wrapper"
					[ngClass]="{
						'bx--date-picker-input__wrapper--invalid': invalid,
						'bx--date-picker-input__wrapper--warn': warn
					}">
					<input
						#input
						*ngIf="!skeleton"
						autocomplete="off"
						type="text"
						class="bx--date-picker__input"
						[ngClass]="{
							'bx--date-picker__input--sm': size === 'sm',
							'bx--date-picker__input--xl': size === 'xl'
						}"
						[attr.data-invalid]="invalid ? true : undefined"
						[value]="value"
						[pattern]="pattern"
						[placeholder]="placeholder"
						[id]= "id"
						[disabled]="disabled"
						(change)="onChange($event)"/>
						<svg
							*ngIf="type !== 'simple' && !warn && !invalid"
							ibmIcon="calendar"
							size="16"
							class="bx--date-picker__icon">
						</svg>
						<svg
							*ngIf="!warn && invalid"
							class="bx--date-picker__icon bx--date-picker__icon--invalid"
							ibmIcon="warning--filled"
							size="16">
						</svg>
						<svg
							*ngIf="!invalid && warn"
							ibmIcon="warning--alt--filled"
							size="16"
							class="bx--date-picker__icon bx--date-picker__icon--warn">
						</svg>
				</div>
				<div
					*ngIf="helperText && !invalid && !warn"
					class="bx--form__helper-text"
					[ngClass]="{'bx--form__helper-text--disabled': disabled}">
					<ng-container *ngIf="!isTemplate(helperText)">{{helperText}}</ng-container>
					<ng-template *ngIf="isTemplate(helperText)" [ngTemplateOutlet]="helperText"></ng-template>
				</div>
				<div *ngIf="!warn && invalid" class="bx--form-requirement">
					<ng-container *ngIf="!isTemplate(invalidText)">{{invalidText}}</ng-container>
					<ng-template *ngIf="isTemplate(invalidText)" [ngTemplateOutlet]="invalidText"></ng-template>
				</div>
				<div *ngIf="!invalid && warn" class="bx--form-requirement">
					<ng-container *ngIf="!isTemplate(warnText)">{{warnText}}</ng-container>
					<ng-template *ngIf="isTemplate(warnText)" [ngTemplateOutlet]="warnText"></ng-template>
				</div>
			</div>
		</div>
</div>
	`,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: DatePickerInput,
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { type: [{
            type: Input
        }], id: [{
            type: Input
        }], hasIcon: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], pattern: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], theme: [{
            type: Input
        }], disabled: [{
            type: Input
        }], invalid: [{
            type: Input
        }], warn: [{
            type: Input
        }], skeleton: [{
            type: Input
        }], value: [{
            type: Input
        }], size: [{
            type: Input
        }], label: [{
            type: Input
        }], invalidText: [{
            type: Input
        }], warnText: [{
            type: Input
        }], helperText: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ["input", { static: false }]
        }] }); })();

class DatePickerInputModule {
}
DatePickerInputModule.ɵfac = function DatePickerInputModule_Factory(t) { return new (t || DatePickerInputModule)(); };
DatePickerInputModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DatePickerInputModule });
DatePickerInputModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        IconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatePickerInputModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DatePickerInput
                ],
                exports: [
                    DatePickerInput
                ],
                imports: [
                    CommonModule,
                    IconModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DatePickerInputModule, { declarations: function () { return [DatePickerInput]; }, imports: function () { return [CommonModule,
        IconModule]; }, exports: function () { return [DatePickerInput]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DatePickerInputModule, DatePickerInput };

